import { EnvironmentProviders, inject, isDevMode, provideAppInitializer, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

import { GOOGLE_TAG_MANAGER_CONFIG_TOKEN } from '../tokens/google-tag-manager-config-token';
import { IGoogleTagManagerConfig } from '../interfaces/i-google-tag-manager-config';

export function provideGoogleTagManagerInitializer(): EnvironmentProviders {
  return provideAppInitializer(async () => {
    const platformId = inject(PLATFORM_ID);
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    const settings = inject(GOOGLE_TAG_MANAGER_CONFIG_TOKEN);
    const document = inject(DOCUMENT);

    await bootstrapGoogleTagManager(settings, document);
  });
}

async function bootstrapGoogleTagManager(
  settings: IGoogleTagManagerConfig,
  document: Document
): Promise<void> {

  if (!settings.trackingCode) {
    if (!isDevMode()) {
      console.error('GoogleTagManager requires a tracking code.');
    }

    return;
  }

  if (!document) {
    if (!isDevMode()) {
      console.error('GoogleTagManager requires a document object.');
    }

    return;
  }

  const window = document.defaultView;
  if (!window) {
    return;
  }

  window['dataLayer'] = window['dataLayer'] || [];
  window['dataLayer'].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const s: HTMLScriptElement = document.createElement('script');
  s.src = `https://www.googletagmanager.com/gtm.js?id=${settings.trackingCode}`;
  s.async = true;

  const firstScript: HTMLScriptElement = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(s, firstScript);
}
